import React from 'react';
import { BuyNowPayLaterMethod } from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { ThemeString } from '../../types/Theme';
import { OpenModal } from '../../types/PaymentMethodsBannerProps';
import { DeviceTypeString } from '../../types/DeviceType';
import { CurrencyString } from '../../types/Currency';
import { CountryString } from '../../types/Country';
import { PaymentMethodsListView } from './view';
import { filterSupportedMethods, areSupportedMethodsChanged } from './utils';
import { withBiLogger, BiLogger } from '../../utils/biLogger';
import { sortPaymentMethodsByRank } from '../../utils/paymentMethods';

export interface PaymentMethodsListProps {
  bnplMethods: BuyNowPayLaterMethod[];
  amount: string;
  currency: CurrencyString;
  deviceType?: DeviceTypeString;
  theme: ThemeString;
  publicBaseUrl: string;
  locale: string;
  country: CountryString;
  biLogger: BiLogger;
  openModal: OpenModal;
  demoMode?: boolean;
}

export interface PaymentMethodsListState {
  supportedMethods: PaymentMethod[];
  filteredMethods: PaymentMethod[];
}

class PaymentMethodsListController extends React.PureComponent<
  PaymentMethodsListProps,
  PaymentMethodsListState
> {
  state: PaymentMethodsListState = {
    supportedMethods: [],
    filteredMethods: [],
  };

  static getDerivedStateFromProps(
    props: PaymentMethodsListProps,
    state: PaymentMethodsListState
  ) {
    const { currency, amount, country, locale, demoMode } = props;
    const supportedMethods = demoMode
      ? sortPaymentMethodsByRank(props.bnplMethods)
      : filterSupportedMethods(
          props.bnplMethods,
          currency,
          amount,
          country,
          locale
        );

    // update state only if supported methods list has changed
    if (
      areSupportedMethodsChanged(
        state.supportedMethods,
        supportedMethods as PaymentMethod[]
      )
    ) {
      return {
        supportedMethods,
      };
    }

    return null;
  }

  componentDidMount() {
    this.props.biLogger?.installmentBannerLoadFinished({
      offerId: this.state.supportedMethods.join(','),
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.supportedMethods !== prevState.supportedMethods) {
      this.props.biLogger?.installmentBannerListLoaded({
        offerId: this.state.supportedMethods.join(','),
      });
    }
  }

  render() {
    const {
      amount,
      currency,
      deviceType,
      publicBaseUrl,
      theme,
      locale,
      country,
      openModal,
      bnplMethods,
    } = this.props;

    const { supportedMethods } = this.state;

    return (
      <PaymentMethodsListView
        paymentMethods={supportedMethods}
        bnplMethods={bnplMethods}
        amount={amount}
        currency={currency}
        deviceType={deviceType}
        theme={theme}
        publicBaseUrl={publicBaseUrl}
        locale={locale}
        country={country}
        openModal={openModal}
      />
    );
  }
}

export const PaymentMethodsList = withBiLogger<PaymentMethodsListProps>(
  PaymentMethodsListController
);
